import React, { useEffect, useState } from 'react';
import {
    Snackbar, Grid2, TextField, Button, Typography, Alert, Dialog, DialogActions, DialogContent, DialogTitle,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box,
    Tooltip
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { taskServices } from '../../services/taskServices';
import '../../css/Form.css';
import TimerIcon from '@mui/icons-material/Timer';
import HistoryIcon from '@mui/icons-material/History';
import PageHeader from '../ui/PageHeader';
import '../../css/DataTable.css';
import '../../css/TeamMembers.css';

const TaskTimeTrack = () => {
    const { t } = useTranslation();
    const [taskId, setTaskId] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [taskDuration, setTaskDuration] = useState('');

    const [subTasksList, setSubTasksList] = useState([]);

    const location = useLocation();
    const task = location.state?.taskData;

    useEffect(() => {
        console.log("Task Data:", task);
        if (task) {
            setTaskId(task.id);
        }
    }, [task]);

    const fetchSubTasksList = (taskId) => {
        taskServices.getAllSubTasksById(taskId)
            .then((response) => {
                console.log("subtasks:", response?.subTasks);
                console.log("grandTotalDuration:", response?.grandTotalDuration);

                setSubTasksList(response?.subTasks);
                setTaskDuration(response?.grandTotalDuration);
            })
            .catch((error) => {
                console.error("Error fetching Sub Tasks List : ", error);
            });
    };

    useEffect(() => {
        if (taskId) {
            fetchSubTasksList(taskId);
        }

    }, [taskId]);

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <Box className="team-members-container">
            <PageHeader 
                title={`${typeof task?.jobName === "string" ? task.jobName : "Extra Task"} : ${task?.title || 'Task'} Time Track`} 
            />

            {taskDuration && (
                <Paper className="action-card" sx={{ py: 3, display: 'flex', alignItems: 'center', gap: 2 }} elevation={0}>
                    <Box sx={{ 
                        p: 1.5, 
                        borderRadius: '0.75rem', 
                        backgroundColor: 'rgba(33, 108, 118, 0.1)', 
                        color: 'var(--primary)' 
                    }}>
                        <TimerIcon sx={{ fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="body2" color="textSecondary" sx={{ fontWeight: 500 }}>
                            Total Accumulated Duration
                        </Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: 'var(--primary)' }}>
                            {taskDuration}
                        </Typography>
                    </Box>
                </Paper>
            )}

            <Box className="member-list-card">
                {subTasksList?.length > 0 ? (
                    <TableContainer>
                        <Table>
                            <TableHead className="modern-table-head">
                                <TableRow>
                                    <TableCell sx={{ width: '40%' }}>Start Time</TableCell>
                                    <TableCell sx={{ width: '40%' }}>End Time</TableCell>
                                    <TableCell>Total Time</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {subTasksList.map((subTask) => (
                                    <TableRow key={subTask.id} className="modern-table-row">
                                        <TableCell className="modern-table-cell">
                                            {new Date(subTask.startTime).toLocaleString()}
                                        </TableCell>
                                        <TableCell className="modern-table-cell">
                                            {subTask.endTime ? new Date(subTask.endTime).toLocaleString() : " --- "}
                                        </TableCell>
                                        <TableCell className="modern-table-cell">
                                            <Typography variant="body2" sx={{ fontWeight: 600, color: 'var(--primary)' }}>
                                                {subTask?.duration}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Box className="empty-state-container">
                        <HistoryIcon className="empty-state-icon" />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: 'var(--text-primary)' }}>
                            No Time History
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            There are no recorded time entries for this task yet.
                        </Typography>
                    </Box>
                )}
            </Box>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} variant="filled">
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default TaskTimeTrack;
